import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { NextPageContext } from 'next';
import { GetAdDetailsResponse, AdDetails } from '../types/ads.types';
import { GET_AD_DETAILS_COMPACT } from '../queries/ads.queries';
import { apolloClient } from '../apolloClient';
import { PlatformSource } from '../types/common.types';

export async function getServerAdDetails(
  client: ApolloClient<NormalizedCacheObject>,
  context: NextPageContext
): Promise<{ adDetails: AdDetails | null }> {
  const legacyId = context.query.slug?.[2] as string;

  if (!legacyId) {
    return { adDetails: null };
  }

  const adDetails = await apolloClient<GetAdDetailsResponse>(
    client,
    {
      query: GET_AD_DETAILS_COMPACT,
      variables: { legacyId, source: PlatformSource.Mobile },
      fetchPolicy: 'no-cache',
    },
    context
  );

  return { adDetails: adDetails?.data.adDetails || null };
}
